const WORDS_PER_MINUTE = 200;

export type ReadingTimeSection = {
	title?: string | null;
	content?: string | null;
};

function htmlToText(html: string) {
	return html
		.replace(/<script[\s\S]*?<\/script>/gi, " ")
		.replace(/<style[\s\S]*?<\/style>/gi, " ")
		.replace(/<[^>]+>/g, " ")
		.replace(/&nbsp;/gi, " ")
		.replace(/&amp;/gi, "&")
		.replace(/&lt;/gi, "<")
		.replace(/&gt;/gi, ">")
		.replace(/&quot;/gi, "\"")
		.replace(/&#39;/gi, "'");
}

function countWords(text: string) {
	return text.trim().match(/[\p{L}\p{N}]+(?:[-'][\p{L}\p{N}]+)?/gu)?.length ?? 0;
}

export function calculateReadingTimeMinutes(sections: ReadingTimeSection[]) {
	const text = sections
		.map((section) => `${section.title ?? ""} ${htmlToText(section.content ?? "")}`)
		.join(" ");

	return Math.max(1, Math.ceil(countWords(text) / WORDS_PER_MINUTE));
}

export function formatReadingTime(minutes: number) {
	const normalized = Math.max(1, Math.trunc(minutes));
	return `${normalized} min read`;
}
